import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoginBgImg from '@src/assets/login-bg.png';
import { Footer } from '@src/components/Footer';
import { ContainerContext } from '@src/contexts';
import classNames from 'classnames';
import { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styles from './LoginLayout.module.scss';
export const LoginLayout = () => {
    const { setShowFooter } = useContext(ContainerContext);
    const location = useLocation();
    useEffect(() => {
        setShowFooter(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs("div", { className: classNames('login-page', styles.container), children: [_jsx("div", { className: styles.contentArea, style: { backgroundImage: `url(${LoginBgImg})` }, children: _jsx("div", { className: styles.main, children: _jsx(Outlet, {}, location.pathname) }) }), _jsx(Footer, {})] }));
};
